import { FormikValues } from 'formik';

export interface IAddressFieldsProps {
	formik: {
		values: FormikValues;
		handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
		setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void;
		touched: FormikValues;
		errors: FormikValues;
		handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	};
	townName?: string;
	addressName: string;
	zipcodeName: string;
	streetName?: string;
	cityName: string;
	stateName: string;
	addressLabel: string;
	mainFieldName?: string;
	townsList?: Townlist[];
	townLabel?: string;
	isEditing: boolean;
}

export type Townlist = {
	id: number;
	value: string;
};

export const GoogleAddressFieldsComponent = ['workshop_address'];
